class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
  }

  connectedCallback() {
    this.performRecommendations();
  }

  performRecommendations() {
    const recommendations = this.querySelector('[data-recommendations]');
    if (!recommendations) return;
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const recommendationsHTML = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-recommendations]').innerHTML;
        if (!recommendationsHTML) return;
        
        this.classList.remove('hidden');
        recommendations.innerHTML = recommendationsHTML;
        this.initSlider();
        this.initRecommendationItems();
      });
  }

  initSlider() {
    this.slider = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 8
    });
  }

  initRecommendationItems() {
    const items = this.querySelectorAll('cart-recommendation-item');
    items.forEach(item => {
      if (!customElements.get('cart-recommendation-item')) {
        customElements.define('cart-recommendation-item', CartRecommendationItem);
      }
    });
  }
}

class CustomDropdown extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.dropdownPortal = null;
    this.selectedValue = '';
    this.selectedText = '';
    // Add this line to track availability
    this.isAvailable = true;
  }

  connectedCallback() {
    this.render();
    this.setupEventListeners();
    this.updateSelectedValue();
  }

  disconnectedCallback() {
    this.removePortal();
    document.removeEventListener('click', this.handleDocumentClick);
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('scroll', this.handleWindowScroll);
  }

  render() {
    const select = this.querySelector('select');
    if (!select) return;

    const options = Array.from(select.options);
    this.selectedValue = select.value;
    this.selectedText = select.selectedOptions[0]?.text || '';
    this.background = select.selectedOptions[0].dataset.image!="undefined" ? `url("${select.selectedOptions[0].dataset.image}") 0 0 / cover no-repeat` : select.selectedOptions[0].dataset.color;
    this.colorSwatch = this.background!="undefined" ? `<span class="custom-dropdown__option--color" style='background:${this.background}'></span>` : ""
    // Explicitly check against string 'true'
    const selectedOption = select.selectedOptions[0];
    const isAvailable = selectedOption?.dataset.available === 'true';
    // Debug log to check values
    // console.log(`Selected option ${this.selectedValue}: available = ${isAvailable}`);
    // const background = option.dataset.image ? `url("${option.dataset.image}") 0 0 / cover no-repeat` : option.dataset.color;
    //  <span class="custom-dropdown__color" style="background:${background}"></span>
    this.innerHTML = `
      <div class="custom-dropdown__trigger ${!isAvailable ? 'is-unavailable' : ''}" role="button" tabindex="0" aria-haspopup="listbox">
        ${this.colorSwatch}
        <span class="custom-dropdown__selected">${this.selectedText}</span>
        <svg class="custom-dropdown__arrow" width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1.25L4.5 4.75L8 1.25" stroke="currentColor" stroke-width="1.2" stroke-linecap="square"/>
          </svg>

      </div>
      <select class="custom-dropdown__select visually-hidden" name="${select.name}" ${select.required ? 'required' : ''}>
        ${options.map(option => `
          
          <option value="${option.value}" 
                  ${option.selected ? 'selected' : ''} 
                  data-image="${option.dataset.image}"
                  data-color="${option.dataset.color}"
                  data-available="${option.dataset.available}">
            ${option.text}
          </option>
        `).join('')}
      </select>
    `;
  }

  setupEventListeners() {
    const trigger = this.querySelector('.custom-dropdown__trigger');
    const select = this.querySelector('.custom-dropdown__select');

    trigger.addEventListener('click', (event) => this.toggle(event));
    trigger.addEventListener('keydown', this.handleKeydown.bind(this));
    select.addEventListener('change', this.handleSelectChange.bind(this));
    
    document.addEventListener('click', this.handleDocumentClick.bind(this));
    window.addEventListener('resize', this.handleWindowResize.bind(this));
    window.addEventListener('scroll', this.handleWindowScroll.bind(this));
  }

  toggle(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (this.isOpen) return;
    
    this.isOpen = true;
    this.classList.add('is-open');
    this.createPortal();
    this.positionDropdown();
    
    // Close other dropdowns
    document.querySelectorAll('custom-dropdown.is-open').forEach(dropdown => {
      if (dropdown !== this) dropdown.close();
    });
  }

  close() {
    if (!this.isOpen) return;
    
    this.isOpen = false;
    this.classList.remove('is-open');
    this.removePortal();
  }

  createPortal() {
    this.removePortal();
    
    const select = this.querySelector('.custom-dropdown__select');
    const options = Array.from(select.options);
    this.dropdownPortal = document.createElement('div');
    this.dropdownPortal.className = 'custom-dropdown__portal';
    this.dropdownPortal.innerHTML = `
      <div class="custom-dropdown__options" role="listbox">
        ${options.map((option, index) => {
          // Explicitly check against string 'true' since dataset values are strings
          const isAvailable = option.dataset.available === 'true';
          const background = option.dataset.image!="undefined" ? `url("${option.dataset.image}") 0 0 / cover no-repeat` : option.dataset.color;
          const colorSwatch = background!="undefined" ? `<span class="custom-dropdown__option--color" style='background:${background}'></span>` : ""
          // Debug log to check values
          // console.log(`Portal option ${option.value}: available = ${isAvailable}`);
          return `
            <div class="custom-dropdown__option ${option.selected ? 'is-selected' : ''} ${!isAvailable ? 'is-unavailable' : ''}" 
                 role="option" 
                 data-value="${option.value}"
                 data-index="${index}"
                 data-available="${isAvailable}"
                 tabindex="0">
                 ${colorSwatch}
                 
              ${option.text}
            </div>
          `;
        }).join('')}
      </div>
    `;

    // Add event listeners to options
    this.dropdownPortal.querySelectorAll('.custom-dropdown__option').forEach(option => {
      option.addEventListener('click', this.handleOptionClick.bind(this));
      option.addEventListener('keydown', this.handleOptionKeydown.bind(this));
    });


    // ДОДАТИ СПЕЦІАЛЬНІ ОБРОБНИКИ ДЛЯ iOS:
  const optionsElement = this.dropdownPortal.querySelector('.custom-dropdown__options');
  
  // Додати touch обробники для iOS
  optionsElement.addEventListener('touchstart', (e) => {
    e.stopPropagation();
  }, { passive: true });
  
  optionsElement.addEventListener('touchmove', (e) => {
    e.stopPropagation();
  }, { passive: false });

  
    document.body.appendChild(this.dropdownPortal);
  }

  removePortal() {
    if (this.dropdownPortal) {
      this.dropdownPortal.remove();
      this.dropdownPortal = null;
    }
  }

  positionDropdown() {
    if (!this.dropdownPortal) return;

    const trigger = this.querySelector('.custom-dropdown__trigger');
    const rect = trigger.getBoundingClientRect();
    const options = this.dropdownPortal.querySelector('.custom-dropdown__options');

    // Position below the trigger
    options.style.position = 'fixed';
    options.style.top = `${rect.bottom + 4}px`;
    options.style.left = `${rect.left}px`;
    options.style.width = `${rect.width}px`;
    options.style.zIndex = '9999';

        // Додати для iOS
    options.style.webkitOverflowScrolling = 'touch';
    options.style.overflowY = 'auto';
    // Adjust if dropdown would go off screen
    const optionsRect = options.getBoundingClientRect();
    if (optionsRect.bottom > window.innerHeight) {
      options.style.top = `${rect.top - optionsRect.height - 4}px`;
    }
    if (optionsRect.right > window.innerWidth) {
      options.style.left = `${window.innerWidth - optionsRect.width - 8}px`;
    }
  }

  handleOptionClick(event) {
    const option = event.target;
    const value = option.dataset.value;
    const text = option.textContent;
    
    this.selectOption(value, text);
    this.close();
  }

  handleOptionKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleOptionClick(event);
    } else if (event.key === 'Escape') {
      this.close();
      this.querySelector('.custom-dropdown__trigger').focus();
    }
  }

  selectOption(value, text) {
    const select = this.querySelector('.custom-dropdown__select');
    const trigger = this.querySelector('.custom-dropdown__selected');
    
    select.value = value;
    trigger.textContent = text;
    this.selectedValue = value;
    this.selectedText = text;
    
    // Update selected state in portal
    if (this.dropdownPortal) {
      this.dropdownPortal.querySelectorAll('.custom-dropdown__option').forEach(option => {
        option.classList.toggle('is-selected', option.dataset.value === value);
      });
    }
    
    // Trigger change event
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  handleSelectChange() {
    this.updateSelectedValue();
  }

  updateSelectedValue() {
    const select = this.querySelector('.custom-dropdown__select');
    const trigger = this.querySelector('.custom-dropdown__selected');
    
    if (select && trigger) {
      this.selectedValue = select.value;
      this.selectedText = select.selectedOptions[0]?.text || '';
      trigger.textContent = this.selectedText;
      if(trigger.previousElementSibling.classList.contains("custom-dropdown__option--color")){
        const background = select.selectedOptions[0].dataset.image!="undefined" ? `url("${select.selectedOptions[0].dataset.image}") 0 0 / cover no-repeat` : select.selectedOptions[0].dataset.color;
        const colorSwatch = background!="undefined" ? `${background}` : "";
        trigger.previousElementSibling.style.background = colorSwatch;

      }
    }
  }

  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggle();
    } else if (event.key === 'Escape') {
      this.close();
    }
  }

  handleDocumentClick = (event) => {
    if (this.isOpen && !this.contains(event.target) && !event.target.closest('.custom-dropdown__portal')) {
      this.close();
    }
  }

  handleWindowResize = () => {
    if (this.isOpen) {
      this.positionDropdown();
    }
  }

  handleWindowScroll = () => {
    if (this.isOpen) {
      this.positionDropdown();
    }
  }

  // Add this method to update availability
  updateAvailability(isAvailable) {
    this.isAvailable = isAvailable;
    const trigger = this.querySelector('.custom-dropdown__trigger');
    trigger?.classList.toggle('is-unavailable', !isAvailable);
  }
}

class CartRecommendationItem extends HTMLElement {
  constructor() {
    super();
    this.variants = [];
    this.currentVariant = null;
    this.cartDrawer = null;
  }

  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
    this.currentVariant = this.variants[0];
    this.cartDrawer = document.querySelector('cart-drawer');
    
    this.initCustomDropdowns();
    this.initVariantSelection();
    this.initAddToCart();
    // this.updateVariant();
  }

  initCustomDropdowns() {
    const selects = this.querySelectorAll('.cart-recommendations__variant-select');
    
    selects.forEach((select, selectIndex) => {
      // If optionIndex is not set, use the select index + 1 as default
      const optionIndex = select.dataset.optionIndex ? 
        parseInt(select.dataset.optionIndex) - 1 : 
        selectIndex;
      
      Array.from(select.options).forEach(option => {
        const optionValue = option.value;
        // Find variant with matching option value
        const matchingVariant = this.variants.find(variant => {
          const variantOptionValue = variant[`option${optionIndex + 1}`];
          const matches = variantOptionValue === optionValue;
          // console.log(`Checking variant ${variant.title}:`, {
          //   variantOptionValue,
          //   lookingFor: optionValue,
          //   matches
          // });
          return matches;
        });
        
        const isAvailable = matchingVariant?.available ?? false;
        option.dataset.available = String(isAvailable);
        option.dataset.image =  option.dataset.image;
        option.dataset.color = option.dataset.color;
        
        // console.log(`Setting availability for ${optionValue}:`, {
        //   variant: matchingVariant,
        //   available: isAvailable
        // });
      });

      const customDropdown = document.createElement('custom-dropdown');
      customDropdown.className = 'cart-recommendations__custom-dropdown';
      customDropdown.appendChild(select.cloneNode(true));
      select.parentNode.replaceChild(customDropdown, select);
    });

    if (!customElements.get('custom-dropdown')) {
      customElements.define('custom-dropdown', CustomDropdown);
    }
  }

  initVariantSelection() {
    const selects = this.querySelectorAll('.cart-recommendations__custom-dropdown select');
    selects.forEach(select => {
      select.addEventListener('change', this.onVariantChange.bind(this));
    });
  }

  initAddToCart() {
    const form = this.querySelector('.cart-recommendations__item-form');
    const submitButton = this.querySelector('.cart-recommendations__item-actions button');
    const event = new Event('submit', {
            'bubbles'    : true, // Whether the event will bubble up through the DOM or not
            'cancelable' : true  // Whether the event may be canceled or not
        });
    if (form) {
      form.addEventListener('submit', this.handleAddToCart.bind(this));
    }
    // if (submitButton && form) {
    //   submitButton.addEventListener('click', function(e){
    //     form.dispatchEvent( event );
    //   });
    // }
  }

  onVariantChange() {
    this.updateVariant();
  }

  updateVariant() {
    const selectedOptions = this.getSelectedOptions();
    this.currentVariant = this.findMatchingVariant(selectedOptions);
    
    if (this.currentVariant) {
      this.updateVariantId();
      this.updateAddToCartButton();
      this.updatePrice();
      this.updateMedia(this.currentVariant)
      
      // Add this line to update dropdown availability
      const dropdowns = this.querySelectorAll('custom-dropdown');
      dropdowns.forEach(dropdown => {
        dropdown.updateAvailability(this.currentVariant.available);
      });
    }
  }
  updateMedia(variant) {
    if (!variant) return;

      const mediaElement = this.querySelector('.cart-recommendations__item-media .media');
      const imageElement = mediaElement?.querySelector('img');
      
      if (!imageElement) return;

      // Use variant image if available, otherwise keep the product's featured image
      const variantImage = variant.featured_image;
      
      // Check for 'src' property instead of 'url'
      if (!variantImage || !variantImage.src) return;

      // Use 'src' property and ensure it has protocol
      let newImageUrl = variantImage.src;
      if (newImageUrl.startsWith('//')) {
        newImageUrl = 'https:' + newImageUrl;
      }
      
      const newImageAlt = variantImage.alt || variant.title || '';

      // Handle both lazy-loaded and native images
      if (imageElement.classList.contains('lazyload')) {
        // For lazy-loaded images, update data-src
        imageElement.setAttribute('data-src', newImageUrl);
        imageElement.setAttribute('alt', newImageAlt);
        
        // If the image has already been loaded, update src as well
        if (imageElement.src && imageElement.src !== '') {
          imageElement.src = newImageUrl;
        }
        
        // Trigger lazy loading update if using a lazy loading library
        if (window.lazySizes) {
          window.lazySizes.loader.unveil(imageElement);
        }
      } else {
        // For native images, update src directly
        imageElement.src = newImageUrl;
        imageElement.setAttribute('alt', newImageAlt);
      }

      // Update srcset if present for responsive images
      if (variantImage.width && variantImage.src) {
        const newSrcset = this.generateSrcset(variantImage);
        if (newSrcset && imageElement.hasAttribute('srcset')) {
          imageElement.setAttribute('srcset', newSrcset);
        }
        if (newSrcset && imageElement.hasAttribute('data-srcset')) {
          imageElement.setAttribute('data-srcset', newSrcset);
        }
      }
    }
    generateSrcset(image) {
      // Add safety checks - use 'src' instead of 'url'
      if (!image || !image.src || !image.width) {
        return '';
      }

      // Generate srcset for responsive images based on Shopify's image transformation
      const widths = [180, 360, 480, 720, 1080];
      const srcsetParts = [];
      
      try {
        let baseUrl = image.src;
        // Ensure protocol is present
        if (baseUrl.startsWith('//')) {
          baseUrl = 'https:' + baseUrl;
        }

        for (const width of widths) {
          if (width <= image.width) {
            // Use Shopify's image transformation URL format
            const transformedUrl = baseUrl.replace(/(\?v=\d+)?(&width=\d+)?$/i, '') + `?v=${Date.now()}&width=${width}`;
            srcsetParts.push(`${transformedUrl} ${width}w`);
          }
        }
        
        // Add the original image as the largest option
        if (srcsetParts.length > 0) {
          srcsetParts.push(`${baseUrl} ${image.width}w`);
        }
        
        return srcsetParts.join(', ');
      } catch (error) {
        return '';
      }
    }
  getSelectedOptions() {
    const options = {};
    const selects = this.querySelectorAll('.cart-recommendations__custom-dropdown select');
    
    selects.forEach(select => {
      const optionName = select.name.replace('options[', '').replace(']', '');
      options[optionName] = select.value;
    });
    
    return options;
  }

  findMatchingVariant(selectedOptions) {
    return this.variants.find(variant => {
      const optionNames = Object.keys(selectedOptions);
      return optionNames.every((optionName, index) => {
        const optionValue = selectedOptions[optionName];
        return variant[`option${index + 1}`] === optionValue;
      });
    });
  }

  updateVariantId() {
    const variantIdInput = this.querySelector('[data-variant-id]');
    if (variantIdInput && this.currentVariant) {
      variantIdInput.value = this.currentVariant.id;
    }
  }

  updateAddToCartButton() {
    const button = this.querySelector('button[type="submit"]');
    if (!button || !this.currentVariant) return;

    const span = button.querySelector('span');
    const textElement = span || button;

    if (this.currentVariant.available) {
      button.disabled = false;
      textElement.textContent = window.cartStrings?.add || 'Add+';
    } else {
      button.disabled = true;
      textElement.textContent = window.cartStrings?.soldOut || 'Sold';
    }
  }

  updatePrice() {
    const priceElement = this.querySelector('.cart-recommendations__item-price');
    if (!priceElement || !this.currentVariant) return;

    const price = this.formatMoney(this.currentVariant.price);
    const compareAtPrice = this.currentVariant.compare_at_price;

    if (compareAtPrice && compareAtPrice > this.currentVariant.price) {
      const formattedCompareAtPrice = this.formatMoney(compareAtPrice);
      priceElement.innerHTML = `
       <span class="visually-hidden">${window.cartStrings?.salePrice || 'Sale price'}</span>
        <ins>${price}</ins>
        <span class="visually-hidden">${window.cartStrings?.regularPrice || 'Regular price'}</span>
        <del>${formattedCompareAtPrice}</del>
      `;
    } else {
      priceElement.innerHTML = `
        <span class="visually-hidden">${window.cartStrings?.regularPrice || 'Regular price'}</span>
        ${price}
      `;
    }
  }
  updateSwatch() {
    const priceElement = this.querySelector('.cart-recommendations__item-price');
    if (!priceElement || !this.currentVariant) return;

    const price = this.formatMoney(this.currentVariant.price);
    const compareAtPrice = this.currentVariant.compare_at_price;

    if (compareAtPrice && compareAtPrice > this.currentVariant.price) {
      const formattedCompareAtPrice = this.formatMoney(compareAtPrice);
      priceElement.innerHTML = `
        <span class="visually-hidden">${window.cartStrings?.salePrice || 'Sale price'}</span>
        <ins>${price}</ins>
        <span class="visually-hidden">${window.cartStrings?.regularPrice || 'Regular price'}</span>
        <del>${formattedCompareAtPrice}</del>
      `;
    } else {
      priceElement.innerHTML = `
        <span class="visually-hidden">${window.cartStrings?.regularPrice || 'Regular price'}</span>
        ${price}
      `;
    }
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(cents / 100);
  }

  async handleAddToCart(event) {
    event.preventDefault();
    
    if (!this.currentVariant || !this.currentVariant.available) {
      this.showErrorMessage('Product is not available');
      return;
    }

    this.setLoadingState(true);
    this.hideMessages();

    try {
      const formData = new FormData(event.target);
      
      // Add sections to update if cart drawer exists
      if (this.cartDrawer) {
        const sections = this.cartDrawer.getSectionsToRender?.()?.map(section => section.section);
        if (sections) {
          formData.append('sections', sections.join(','));
        }
        formData.append('sections_url', window.location.pathname);
      }

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (response.ok) {
        const data = await response.json();
        this.showSuccessMessage();
        
        // Update cart drawer if available
        if (this.cartDrawer && data.sections) {
          this.cartDrawer.renderContents(data);
        }
        // Dispatch cart update event
        document.dispatchEvent(new CustomEvent('cart:updated', { 
          detail: { items: data.items || [] }
        }));
        
      } else {
        const errorData = await response.json();
        this.showErrorMessage(errorData.message || 'Failed to add to cart');
      }
    } catch (error) {
      // console.error('Add to cart error:', error);
      this.showErrorMessage('Something went wrong! Please try again later.');
    } finally {
      this.setLoadingState(false);
    }
  }

  setLoadingState(isLoading) {
    const item = this.closest('.cart-recommendations__item');
    if (item) {
      item.classList.toggle('is-loading', isLoading);
    }
  }

  showSuccessMessage() {
    const messages = this.querySelector('.cart-recommendations__item-messages');
    const successMessage = this.querySelector('.cart-recommendations__success-message');
    
    if (messages && successMessage) {
      messages.classList.remove('hidden');
      successMessage.classList.remove('hidden');
      
      // Hide after 3 seconds
      setTimeout(() => {
        this.hideMessages();
      }, 3000);
    }
  }

  showErrorMessage(message) {
    const messages = this.querySelector('.cart-recommendations__item-messages');
    const errorMessage = this.querySelector('.cart-recommendations__error-message');
    
    if (messages && errorMessage) {
      messages.classList.remove('hidden');
      errorMessage.classList.remove('hidden');
      
      const messageText = errorMessage.querySelector('span');
      if (messageText) {
        messageText.textContent = message;
      }
      
      // Hide after 5 seconds
      setTimeout(() => {
        this.hideMessages();
      }, 5000);
    }
  }

  hideMessages() {
    const messages = this.querySelector('.cart-recommendations__item-messages');
    const successMessage = this.querySelector('.cart-recommendations__success-message');
    const errorMessage = this.querySelector('.cart-recommendations__error-message');
    
    if (messages) messages.classList.add('hidden');
    if (successMessage) successMessage.classList.add('hidden');
    if (errorMessage) errorMessage.classList.add('hidden');
  }
}

customElements.define('cart-recommendations', CartRecommendations);
